import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Panindiacabservicefrompune() {



const cardData = {
  keyword: "Explorer pan India cab service from Pune ",

"headingDescription": "SRS Cab Service offers Pan India Cab Service from Pune, providing safe, reliable, and comfortable travel solutions for outstation trips across India. Whether it’s business travel, family vacations, airport transfers, or long-distance journeys, our well-maintained fleet and professional drivers ensure a smooth and hassle-free experience. With flexible booking options, transparent pricing, and 24/7 customer support, SRS Cab Service makes traveling from Pune to any city in India convenient, timely, and stress-free.",
"topPlaces": [
  {
    "title": "Mumbai",
    "description": "A frequent destination for travelers using SRS Cab Service Pan India Cabs from Pune for business, leisure, and airport transfers."
  },
  {
    "title": "Nasik",
    "description": "Visitors and business travelers rely on SRS Cab Service for comfortable and timely cab trips from Pune to Nasik."
  },
  {
    "title": "Mahabaleshwar",
    "description": "Popular hill station accessible via SRS Cab Service Pan India Cabs for family trips and leisure travel from Pune."
  },
  {
    "title": "Lonavala",
    "description": "A scenic getaway from Pune where travelers frequently use SRS Cab Service for safe and reliable outstation cab rides."
  },
  {
    "title": "Shirdi",
    "description": "Pilgrims traveling from Pune use SRS Cab Service for Pan India cab trips to Shirdi, ensuring comfort and timely arrival."
  },
  {
    "title": "Bhimashankar",
    "description": "Adventure and spiritual travelers rely on SRS Cab Service for safe outstation travel from Pune to Bhimashankar."
  },
  {
    "title": "Goa",
    "description": "Tourists and corporate travelers use SRS Cab Service for long-distance trips from Pune to Goa, ensuring a hassle-free journey."
  },
  {
    "title": "Nagpur",
    "description": "Business travelers and tourists use SRS Cab Service for Pan India cab services from Pune to Nagpur with comfort and reliability."
  },
  {
    "title": "Indore",
    "description": "Professionals and families traveling from Pune to Indore rely on SRS Cab Service for safe and smooth cab trips across states."
  },
  {
    "title": "Konkan Region",
    "description": "Travelers exploring Maharashtra’s coastal areas use SRS Cab Service Pan India Cabs for seamless journeys from Pune to Konkan destinations."
  }
],



services: [
{
name: "Pune to Ayodhya Cab Service",
description: "Pune to Ayodhya cab service offers reliable long-distance travel for pilgrims and tourists. Customers can book cabs for one way and round trips. Professional drivers ensure safe highway journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Pune to Taj Mahal Cabs Service",
description: "Pune to Taj Mahal cabs service provides comfortable travel for sightseeing and tours. Customers can book cabs for Agra trips easily. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Pune to Kolkata Taxi Fare",
description: "Pune to Kolkata taxi fare offers transparent pricing for long-distance travel. Customers can plan trips with affordable fare options. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Pune to Goa Taxi Fare",
description: "Pune to Goa taxi fare provides budget-friendly pricing for beach travel and tours. Customers can book cabs for one way or round trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Pune to Chennai Cab Service",
description: "Pune to Chennai cab service offers reliable travel for long-distance business and personal trips. Customers can book cabs easily. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Pune to Delhi Cab Service",
description: "Pune to Delhi cab service provides comfortable travel for long-distance journeys. Customers can book cabs for business and family trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Pune to Mysore Ooty Cab Package",
description: "Pune to Mysore Ooty cab package offers scenic travel for hill station tours. Customers can explore multiple destinations comfortably. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible tour plans are available. Travel easily with cab packages."
},
{
name: "Pune to Kanyakumari Taxi Package",
description: "Pune to Kanyakumari taxi package provides long-distance travel for South India tours. Customers can book cabs for multi-day trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible plans are available. Travel easily with taxi packages."
},
{
name: "Pune to Kerala Cab Package",
description: "Pune to Kerala cab package offers comfortable travel for scenic backwater tours. Customers can explore Kerala destinations easily. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible tour plans are available. Travel easily with cab packages."
},
{
name: "Taxi Booking Service in Pune",
description: "Taxi booking service in Pune provides easy and quick cab booking options for local and outstation travel. Customers can book taxis anytime. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Pune to Bhopal Cab Service",
description: "Pune to Bhopal cab service offers reliable travel for long-distance routes. Customers can book cabs for business and personal trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Best Travel Agents in Pimpri Chinchwad",
description: "Best travel agents in Pimpri Chinchwad provide complete tour planning and cab booking services. Customers can book travel packages easily. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible tour options are available. Travel easily with travel agents."
},
{
name: "Pune to Nagpur Cab Booking",
description: "Pune to Nagpur cab booking offers convenient travel for long-distance journeys. Customers can book cabs for one way and round trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Pune to Patna Cab Service",
description: "Pune to Patna cab service provides reliable travel for long-distance trips. Customers can book cabs for personal and business journeys. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Pune to Madras Cab Service",
description: "Pune to Madras cab service offers comfortable travel for long-distance routes. Customers can book cabs for South India travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services."
},
{
name: "Pune to 12 Jyotirlinga Darshan Tour Package",
description: "Pune to 12 Jyotirlinga darshan tour package offers spiritual travel across India. Customers can visit all Jyotirlinga temples comfortably. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible tour plans are available. Travel easily with darshan packages."
},
{
name: "Pune to 5 Jyotirlinga Darshan Cabs",
description: "Pune to 5 Jyotirlinga darshan cabs provide convenient travel for religious trips. Customers can visit multiple temples easily. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible tour plans are available. Travel easily with cab services."
},
{
name: "Pune to Ashtavinayak Darshan Cab",
description: "Pune to Ashtavinayak darshan cab offers spiritual travel across Maharashtra temples. Customers can visit all eight temples comfortably. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible tour plans are available. Travel easily with darshan cab services."
},
{
name: "Pan India Cab Service Pune",
description: "Pan India cab service Pune offers long-distance travel across India. Customers can book cabs for any city and state. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with Pan India cab services."
},
{
name: "Pune to Pan India Taxi Service",
description: "Pune to Pan India taxi service provides nationwide travel for business and tourism. Customers can book taxis for long-distance trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Innova Cab Booking Online Pune",
description: "Innova cab booking online Pune offers easy booking for spacious SUV travel. Customers can book vehicles for local and outstation trips. Professional drivers ensure safe journeys. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with Innova services."
},
{
name: "Innova Crysta Cab Booking Online Pune",
description: "Innova Crysta cab booking online Pune provides premium SUV travel for comfort and luxury. Customers can book vehicles easily online. Professional drivers ensure safe journeys. Spacious seating enhances experience. Flexible booking options are available. Travel easily with Innova Crysta services."
}
],

tableData: [
["Pune to Ayodhya Cab Service","Pune to Taj Mahal Cabs Service"],
["Pune to Kolkata Taxi Fare","Pune to Goa Taxi Fare"],
["Pune to Chennai Cab Service","Pune to Delhi Cab Service"],
["Pune to Mysore Ooty Cab Package","Pune to Kanyakumari Taxi Package"],
["Pune to Kerala Cab Package","Taxi Booking Service in Pune"],
["Pune to Bhopal Cab Service","Best Travel Agents in Pimpri Chinchwad"],
["Pune to Nagpur Cab Booking","Pune to Patna Cab Service"],
["Pune to Madras Cab Service","Pune to 12 Jyotirlinga Darshan Tour Package"],
["Pune to 5 Jyotirlinga Darshan Cabs","Pune to Ashtavinayak Darshan Cab"],
["Pan India Cab Service Pune","Pune to Pan India Taxi Service"],
["Innova Cab Booking Online Pune","Innova Crysta Cab Booking Online Pune"]
],



whychoose: [
  {
    WhyChooseheading: "Pan India Cab Service from Pune",
    WhyChoosedescription: "SRS Cab Service offers reliable Pan India cab service from Pune to all major cities across India including Mumbai, Delhi, Bangalore, Hyderabad, Goa, Ahmedabad, and more with seamless travel experience."
  },
  {
    WhyChooseheading: "Nationwide Travel with One Trusted Partner",
    WhyChoosedescription: "Book one cab service for travel across India with consistent quality, professional drivers, and well-maintained vehicles for long-distance journeys."
  },
  {
    WhyChooseheading: "Affordable & Transparent Long-Distance Pricing",
    WhyChoosedescription: "We provide cost-effective Pan India cab services with transparent pricing including tolls, driver allowance, and no hidden charges for long trips."
  },
  {
    WhyChooseheading: "24/7 Cab Availability Across India",
    WhyChoosedescription: "Our Pan India cab service operates 24/7, allowing you to travel anytime for business trips, family vacations, or urgent long-distance journeys."
  },
  {
    WhyChooseheading: "Wide Range of Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars like Dzire, SUVs like Ertiga and Innova, premium Innova Crysta, Tempo Travellers, Urbania vans, and luxury vehicles for comfortable nationwide travel."
  },
  {
    WhyChooseheading: "Experienced Drivers for Long Routes",
    WhyChoosedescription: "Our drivers are experienced in long-distance travel across highways, hill routes, and intercity journeys ensuring safe and smooth rides."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "We offer one-way cab service, round-trip bookings, and multi-day packages for Pan India travel from Pune."
  },
  {
    WhyChooseheading: "Trusted Pan India Cab Provider",
    WhyChoosedescription: "SRS Cab Service is trusted by travelers for reliable, comfortable, and affordable cab services across India from Pune."
  }
]
}

const faqData = [
  { 
    question: "Do you provide Pan India cab service from Pune?", 
    answer: "Yes, SRS Cab Service offers Pan India cab service from Pune to major cities like Mumbai, Delhi, Bangalore, Hyderabad, Goa, Ahmedabad, and many more destinations across India." 
  },
  { 
    question: "Can I travel long distance across states by cab?", 
    answer: "Yes, we provide long-distance cab services across states with comfortable vehicles and experienced drivers for safe intercity travel." 
  },
  { 
    question: "Is Pan India cab service available 24/7?", 
    answer: "Yes, our Pan India cab service operates 24/7 so you can travel anytime based on your schedule." 
  },
  { 
    question: "Which vehicles are available for long-distance travel?", 
    answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, Tempo Travellers, Urbania vans, and luxury vehicles for comfortable long journeys." 
  },
  { 
    question: "Do you provide one-way cab service across India?", 
    answer: "Yes, we provide one-way cab services for multiple routes across India, making travel more affordable compared to round trips." 
  },
  { 
    question: "Are drivers experienced for long-distance travel?", 
    answer: "Yes, all drivers are experienced in highway driving, long routes, and intercity travel ensuring safety and smooth journey." 
  },
  { 
    question: "Are cab fares transparent for Pan India trips?", 
    answer: "Yes, we provide transparent pricing with complete fare details including tolls and driver allowance without hidden charges." 
  },
  { 
    question: "Can I book cab for multi-day trips?", 
    answer: "Yes, we offer multi-day cab packages for long trips across India with flexible travel plans." 
  },
  { 
    question: "Is service available for family and group travel?", 
    answer: "Yes, we provide spacious vehicles like Ertiga, Innova, Tempo Travellers, and Urbania for family and group travel." 
  },
  { 
    question: "How can I book Pan India cab service from Pune?", 
    answer: "You can easily book Pan India cab service by contacting us directly. We provide quick booking and customized travel plans." 
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rajesh Sharma",
    feedback:
      "I booked a cab from Pune to Bangalore and the experience was excellent. The journey was comfortable, driver was experienced, and everything was managed perfectly.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Sneha Patil",
    feedback:
      "Best Pan India cab service from Pune. I traveled to Goa with family and the trip was smooth and enjoyable. Clean vehicle, professional driver, and affordable pricing.",
    rating: 5
  }
];



















const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];












const jsonData = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "name": "SRS Cab - Pan India Explorer Cab Service from Pune",
  "description": "Reliable pan India cab service from Pune with SRS Cab. Book cabs for long-distance travel to cities like Ayodhya, Taj Mahal, Kolkata, Goa, Chennai, Delhi, Mysore, Ooty, Kanyakumari, Kerala, Bhopal, Nagpur, Patna, and Madras. 24/7 service with Innova, Ertiga, Dzire, sedan, SUV, and tempo traveller options.",
  "image": "https://www.srscabservice.com/logo.png",
  "telephone": "+91 9011955415",
  "address": {
    "@type": "PostalAddress",
    "streetAddress": "Pune",
    "addressLocality": "Pune",
    "addressRegion": "Maharashtra",
    "postalCode": "411001",
    "addressCountry": "IN"
  },
  "geo": {
    "@type": "GeoCoordinates",
    "latitude": "18.5204",
    "longitude": "73.8567"
  },
  "url": "https://www.srscabservice.com/pan-india-cab-service-from-pune",
  "priceRange": "₹₹",
  "openingHours": "Mo-Su 00:00-23:59",
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "bestRating": "5",
    "worstRating": "1",
    "ratingCount": "1475"
  },
  "areaServed": {
    "@type": "City",
    "name": "Pune, Maharashtra"
  }
};






  return (
    <div>
      
<Helmet>
  <title>Pan India Cab Service from Pune | Call +91 9011955415 | SRS Cab</title>
  <meta 
    name="description" 
    content="Book reliable pan India cab service from Pune with SRS Cab. Travel to Ayodhya, Taj Mahal, Kolkata, Goa, Chennai, Delhi, Mysore, Ooty, Kanyakumari, Kerala, Bhopal, Nagpur, Patna, and more. Innova, Ertiga, sedan, SUV, and tempo traveller options available 24/7." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>




 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/109.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Panindiacabservicefrompune;